<div class="pce-card" [formGroup]="contactForm">

    <!-- Header -->
    <app-profile-section-header title="Mi perfil"
                                subtitle="Consulta tu información personal y datos de contacto">
        <svg headerIcon viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">
            <circle cx="12" cy="8" r="4"/>
            <path d="M4 21c0-4 4-7 8-7s8 3 8 7" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    </app-profile-section-header>

    <!-- Datos personales -->
    <div class="pce-section">
        <div class="pce-section__heading">
            <h3 class="pce-section__title">Datos personales</h3>
            <div class="pce-section__progress">
                <app-profile-complete-bar [percent]="contactProgress"></app-profile-complete-bar>
            </div>
        </div>

        <div class="pce-form">

            <div class="pce-row pce-row--2col">
                <div class="pce-input-group">
                    <label class="pce-label">Nombre</label>
                    <input type="text" class="pce-input" formControlName="name" maxlength="160"
                        [ngClass]="{'pce-input--error': isInvalid('name')}">
                    <span class="pce-field-error" *ngIf="isInvalid('name')">(*) Campo obligatorio</span>
                </div>
                <div class="pce-input-group">
                    <label class="pce-label">Primer apellido</label>
                    <input type="text" class="pce-input" formControlName="surname" maxlength="60"
                        [ngClass]="{'pce-input--error': isInvalid('surname')}">
                    <span class="pce-field-error" *ngIf="isInvalid('surname')">(*) Campo obligatorio</span>
                </div>
            </div>

            <div class="pce-row pce-row--2col">
                <div class="pce-input-group">
                    <label class="pce-label">Segundo apellido</label>
                    <input type="text" class="pce-input" formControlName="lastName" maxlength="60">
                </div>
                <div class="pce-row pce-row--2col">
                    <div class="pce-input-group">
                        <label class="pce-label">Documento</label>
                        <div class="pce-input pce-input--readonly">{{ documentType }}</div>
                    </div>
                    <div class="pce-input-group">
                        <label class="pce-label">Nº de documento</label>
                        <div class="pce-input pce-input--readonly">{{ documentNumber }}</div>
                    </div>
                </div>
            </div>

            <div class="pce-row pce-row--2col">
                <div class="pce-input-group">
                    <label class="pce-label">E-mail</label>
                    <input type="email" class="pce-input" formControlName="email" maxlength="128"
                        [ngClass]="{'pce-input--error': isInvalid('email')}">
                    <span class="pce-field-error" *ngIf="isInvalid('email')">(*) Campo obligatorio</span>
                </div>
                <div class="pce-input-group" *ngIf="!isCompany">
                    <app-date-picker label="Fecha de nacimiento" formControlName="birthDate"
                        errorDescription="(*) Campo obligatorio"
                        correctDayAndMonthErrorDescription="El día, mes o año es erróneo"
                        beforeCurrentDateErrorDescription="La fecha debe ser menor o igual que el día actual"
                        minAgeErrorDescription="Debes ser mayor de edad">
                    </app-date-picker>
                </div>
            </div>

            <div class="pce-row pce-row--2col">
                <div class="pce-input-group">
                    <label class="pce-label">Teléfono fijo</label>
                    <div class="pce-phone-row">
                        <div class="pce-prefix">
                            <angular2-multiselect [data]="prefixData" [settings]="prefixSettings"
                                formControlName="phonePrefix" (ngModelChange)="cambioPrefijo('phone', $event)">
                                <c-badge>
                                    <ng-template let-item="item">
                                        <label class="phoneBadge">
                                            <span *ngIf="undefined !== item.id" class="flags flag{{item.id}}"></span>
                                            <span *ngIf="undefined !== item.id">+{{item.id}}</span>
                                            <span *ngIf="undefined !== item.id">{{item.itemName}}</span>
                                        </label>
                                    </ng-template>
                                </c-badge>
                                <c-item>
                                    <ng-template let-item="item">
                                        <label class="phoneItem" style="min-width: 220px; font-family: 'AVENIR';">
                                            <span class="flags flag{{item.id}}"></span>
                                            <span>+{{item.id}}</span>
                                            <span>{{item.itemName}}</span>
                                        </label>
                                    </ng-template>
                                </c-item>
                            </angular2-multiselect>
                        </div>
                        <input type="text" class="pce-input pce-input--phone" formControlName="phone"
                            maxlength="18" [ngClass]="{'pce-input--error': isInvalid('phone')}">
                    </div>
                    <span class="pce-field-error" *ngIf="isInvalid('phone')">Número no válido</span>
                    <span class="pce-field-error" *ngIf="hasError('phonePrefix', 'prefixRequired')">(*) Selecciona el prefijo del teléfono</span>
                    <span class="pce-field-error" *ngIf="hasError('phonePrefix', 'prefixNotAllowed')">(*) Indica el teléfono o quita el prefijo</span>
                </div>

                <div class="pce-input-group">
                    <label class="pce-label">Teléfono móvil</label>
                    <div class="pce-phone-row">
                        <div class="pce-prefix">
                            <angular2-multiselect [data]="prefixData" [settings]="prefixSettings"
                                formControlName="mobilePhonePrefix" (ngModelChange)="cambioPrefijo('mobilePhone', $event)">
                                <c-badge>
                                    <ng-template let-item="item">
                                        <label class="phoneBadge">
                                            <span *ngIf="undefined !== item.id" class="flags flag{{item.id}}"></span>
                                            <span *ngIf="undefined !== item.id">+{{item.id}}</span>
                                            <span *ngIf="undefined !== item.id">{{item.itemName}}</span>
                                        </label>
                                    </ng-template>
                                </c-badge>
                                <c-item>
                                    <ng-template let-item="item">
                                        <label class="phoneItem" style="min-width: 220px; font-family: 'AVENIR';">
                                            <span class="flags flag{{item.id}}"></span>
                                            <span>+{{item.id}}</span>
                                            <span>{{item.itemName}}</span>
                                        </label>
                                    </ng-template>
                                </c-item>
                            </angular2-multiselect>
                        </div>
                        <input type="text" class="pce-input pce-input--phone" formControlName="mobilePhone"
                            maxlength="18" [ngClass]="{'pce-input--error': isInvalid('mobilePhone')}">
                    </div>
                    <span class="pce-field-error" *ngIf="isInvalid('mobilePhone')">(*) Campo obligatorio</span>
                    <span class="pce-field-error" *ngIf="hasError('mobilePhonePrefix', 'prefixRequired')">(*) Selecciona el prefijo del teléfono móvil</span>
                    <span class="pce-field-error" *ngIf="hasError('mobilePhonePrefix', 'prefixNotAllowed')">(*) Indica el teléfono móvil o quita el prefijo</span>
                </div>
            </div>

        </div>
    </div>

    <!-- Domicilio -->
    <div class="pce-section">
        <div class="pce-section__heading">
            <h3 class="pce-section__title">Domicilio</h3>
            <div class="pce-section__progress">
                <app-profile-complete-bar [percent]="addressProgress"></app-profile-complete-bar>
            </div>
        </div>

        <div class="pce-form">

            <div class="pce-row pce-row--2col">
                <div class="pce-input-group">
                    <label class="pce-label">Código postal</label>
                    <div class="pce-postal-row">
                        <input type="text" class="pce-input" formControlName="postalCode" maxlength="5"
                            (keyup)="onChangePostalCode($event)"
                            [ngClass]="{'pce-input--error': isInvalid('postalCode')}">
                        <button type="button" class="pce-search-btn" (click)="searchCity()">
                            <i class="fa fa-search" aria-hidden="true"></i>
                            <span>Buscar</span>
                        </button>
                    </div>
                    <span class="pce-field-error" *ngIf="isInvalid('postalCode')">(*) Campo obligatorio</span>
                </div>
                <div class="pce-input-group">
                    <label class="pce-label">Población</label>
                    <angular2-multiselect [data]="cityList" [settings]="citySettings" formControlName="cityCb"
                        (onSelect)="onCitySelect($event)">
                    </angular2-multiselect>
                    <span *ngIf="loadingCities" class="pce-spinner"></span>
                    <span class="pce-field-error" *ngIf="isInvalid('cityCb')">(*) Campo obligatorio</span>
                </div>
            </div>

            <div class="pce-input-group">
                <label class="pce-label">Provincia</label>
                <div class="pce-input pce-input--disabled">{{ province }}</div>
                <p class="pce-province-hint">Se autocompleta al buscar el código postal</p>
            </div>

            <div class="pce-row pce-row--road">
                <div class="pce-input-group">
                    <label class="pce-label">Tipo vía</label>
                    <angular2-multiselect [data]="roadTypeList" [settings]="roadTypeSettings"
                        formControlName="roadType">
                    </angular2-multiselect>
                    <span class="pce-field-error" *ngIf="isInvalid('roadType')">(*) Campo obligatorio</span>
                </div>
                <div class="pce-input-group">
                    <label class="pce-label">Domicilio</label>
                    <input type="text" class="pce-input" formControlName="address" maxlength="80"
                        [ngClass]="{'pce-input--error': isInvalid('address')}">
                    <span class="pce-field-error" *ngIf="isInvalid('address')">(*) Campo obligatorio</span>
                </div>
            </div>

            <div class="pce-row pce-row--5col">
                <div class="pce-input-group">
                    <label class="pce-label">Número</label>
                    <input type="text" class="pce-input" formControlName="number" maxlength="5"
                        [ngClass]="{'pce-input--error': isInvalid('number')}">
                    <span class="pce-field-error" *ngIf="isInvalid('number')">(*) Campo obligatorio</span>
                </div>
                <div class="pce-input-group">
                    <label class="pce-label">Portal</label>
                    <input type="text" class="pce-input" formControlName="portal" maxlength="32">
                </div>
                <div class="pce-input-group">
                    <label class="pce-label">Escalera</label>
                    <input type="text" class="pce-input" formControlName="stair" maxlength="16">
                </div>
                <div class="pce-input-group">
                    <label class="pce-label">Piso</label>
                    <input type="text" class="pce-input" formControlName="floor" maxlength="20">
                </div>
                <div class="pce-input-group">
                    <label class="pce-label">Puerta</label>
                    <input type="text" class="pce-input" formControlName="door" maxlength="16">
                </div>
            </div>

        </div>
    </div>

    <div class="pce-footer__messages" *ngIf="messages && messages.length > 0">
        <span *ngFor="let msg of messages">{{ msg }}</span>
    </div>

    <div class="pce-footer">
    <div class="pce-footer__actions">
        <button type="button" class="pce-btn pce-btn--cancel" (click)="onCancel()">
            Cancelar
        </button>
        <app-spinner-button
            [label]="getButtonLabel()"
            [enabled]="!running"
            [running]="running"
            (click)="onSave()">
        </app-spinner-button>
    </div>
    </div>
</div>

